// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { DocumentModel } from "@insite/client-framework/Types/ApiModels";
import { CustomAppState } from "@sc/App/Store/Reducers";

type VideoAndDocumentSelector = { videos: DocumentModel[]; others: DocumentModel[] };
export const getProductVideosAndDocumentsState = (state: CustomAppState, produceId: string) => {
    const documents = state.data.products.byId[produceId]?.documents || [];
    const youtubeVimeoRegex =
        /^.*((youtu.be\/|vimeo.com\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(video\/)|(watch\?))\??v?=?([^#\&\?]*).*/i;
    const documentCategories = documents.reduce(
        (acc: VideoAndDocumentSelector, document) => {
            if (document.filePath.match(youtubeVimeoRegex) || document.filePath.includes(".mp4")) {
                acc.videos.push(document);
            } else {
                acc.others.push(document);
            }
            return acc;
        },
        { videos: [], others: [] },
    );

    return documentCategories;
};
